import { render, staticRenderFns } from "./DialogInvoiceDetails.vue?vue&type=template&id=01520037&scoped=true&"
import script from "./DialogInvoiceDetails.vue?vue&type=script&lang=js&"
export * from "./DialogInvoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./DialogInvoiceDetails.vue?vue&type=style&index=0&id=01520037&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01520037",
  null
  
)

export default component.exports